var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 1.83238V0.639044C6.00002 0.339044 5.64002 0.192377 5.43335 0.40571L3.56669 2.26571C3.43335 2.39904 3.43335 2.60571 3.56669 2.73904L5.42669 4.59904C5.64002 4.80571 6.00002 4.65904 6.00002 4.35904V3.16571C8.20669 3.16571 10 4.95904 10 7.16571C10 8.97904 8.78002 10.5124 7.12669 10.999C6.84669 11.079 6.66669 11.3457 6.66669 11.6324C6.66669 12.0657 7.08002 12.4057 7.50002 12.279C9.71335 11.6324 11.3334 9.59238 11.3334 7.16571C11.3334 4.21904 8.94669 1.83238 6.00002 1.83238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 7.16575C2.00002 6.27241 2.29335 5.44575 2.79335 4.77242C2.99335 4.50575 2.96669 4.13908 2.73335 3.89908C2.45335 3.61908 1.97335 3.64575 1.73335 3.96575C1.06669 4.85908 0.666687 5.96575 0.666687 7.16575C0.666687 9.59241 2.28669 11.6324 4.50002 12.2791C4.92002 12.4057 5.33335 12.0657 5.33335 11.6324C5.33335 11.3457 5.15335 11.0791 4.87335 10.9991C3.22002 10.5124 2.00002 8.97908 2.00002 7.16575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetTrade);
export default __webpack_public_path__ + "static/media/reset_trade.4d60ef21d74327c735a9430331fe2d29.svg";
export { ForwardRef as ReactComponent };